import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPlus, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import MasterServices from "../../services/axioServices/apiServices/MasterServices.js";
import { CommonSuccessMessages, CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import ToggleSwitch from "../../components/common/ToggleSwitch.js";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";

class rawMaterial extends Component {
  constructor(props) {
    super(props);
    this.masterServices = new MasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      isPharmaSoftware: false,
      _id: "",
      rawMaterialsLising: [],
      tableStatus: "",
      isLoading: false,
      totalCount: 0,
      isEditing: false,
      isGridView: true,
      rawMaterialDetails: {
        rmCode: "",
        rmName: "",
        packing: "",
        eqTo: "",
        specification: "",
        specificationNo: "",
        rmUOM: "",
        rmCategory: "",
        rmPurchaseRate: null,
        rmPackQty: null,
        testingCharge: null,
        storageCondition: "",
        minQty: null,
        maxQty: null,
        sampleQty: null,
        reTestPeriod: null,
        batchWeight: "",
        assayCount: "",
        moistureCount: "",
        labTestRequire: false,
      },
      rmCategoryList: [],
      storageConditionList: [],
      rmUOMList: [
        { uom: "GM" },
        { uom: "KGS" },
        { uom: "IU" },
        { uom: "LTR" },
        { uom: "MCG" },
        { uom: "MG" },
        { uom: "ML" },
        { uom: "NOS" },
      ],
      searchByItemName: "",
      validationRules: {
        rmName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "item name"
            ),
          },
        ],
        rmUOM: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "uom"
            ),
          },
        ],
        rmCategory: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "category"
            ),
          },
        ],
        rmPurchaseRate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "purchase rate"
            ),
          },
        ],
        // rmPackQty: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "packing qty"
        //     ),
        //   },
        // ],
        // testingCharge: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "testing charge"
        //     ),
        //   },
        // ],
        storageCondition: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "storage condition"
            ),
          },
        ],
        // minQty: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "minimum qty"
        //     ),
        //   },
        // ],
        // maxQty: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "maximum qty"
        //     ),
        //   },
        // ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    if (!this.isCalled) {
      this.getAllRawMaterials(this.state.searchByItemName);
      this.isCalled = true;
    }

    let cookies = getAuthProps()
    if (cookies) {
      this.setState({ isPharmaSoftware: cookies.isPharmaSoftware })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.searchByItemName !== this.state.searchByItemName && !this.isCalled) {
      this.getAllRawMaterials(this.state.searchByItemName);
      this.isCalled = true;
    }
  }

  getAllRawMaterials = (ItemName) => {
    this.setState({ tableStatus: "Loading..." })
    let request = [ItemName]
    this.masterServices.getAllRawMaterials(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {

        let totalCount = response.responseData.totalCount;
        if (totalCount === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        const newMaterials = response.responseData.responseData;
        this.setState({ rawMaterialsLising: newMaterials, totalCount: totalCount }, () => {
          this.getAllStorageConditions();
        })
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
        this.getAllStorageConditions();
      }
    });
  };

  getRawMaterialById = (id) => {
    this.masterServices.getRawMaterialById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let details = response.responseData;
        details.rmPurchaseRate = Number(details.rmPurchaseRate) > 0 ? Number(details.rmPurchaseRate).toFixed(3) : 0;
        details.rmPackQty = Number(details.rmPackQty) > 0 ? Number(details.rmPackQty).toFixed(3) : 0;
        details.testingCharge = Number(details.testingCharge) > 0 ? Number(details.testingCharge).toFixed(3) : 0;
        details.minQty = Number(details.minQty) > 0 ? Number(details.minQty).toFixed(2) : 0;
        details.maxQty = Number(details.maxQty) > 0 ? Number(details.maxQty).toFixed(2) : 0;
        details.sampleQty = Number(details.sampleQty) > 0 ? Number(details.sampleQty).toFixed(2) : 0;
        if (details.batchWeight === 0) {
          details.batchWeight = "No";
        } else {
          details.batchWeight = "Yes";
        }
        if (details.assayCount === 0) {
          details.assayCount = "No";
        } else {
          details.assayCount = "Yes";
        }
        if (details.moistureCount === 0) {
          details.moistureCount = "No";
        } else {
          details.moistureCount = "Yes";
        }
        details.labTestRequire = details.labTestRequire ? 1 : 0;
        this.setState({ rawMaterialDetails: details, _id: details._id }, () => {
          this.setState({ isEditing: true, isGridView: false });
        });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllStorageConditions = () => {
    this.commonServices.getAllStorageConditions().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ storageConditionList: response.responseData }, () => {
          this.getAllRMCategory();
        });
      } else {
        this.getAllRMCategory();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllRMCategory = () => {
    this.commonServices.getAllRMCategory().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ rmCategoryList: response.responseData });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.rawMaterialDetails;
    details[name] = value.toUpperCase();
    this.setState({ userDetails: details });
  };

  handleDropdownChange = (e, name) => {
    const selectedYear = e.target.value;
    let details = this.state.rawMaterialDetails;
    details[name] = selectedYear;
    this.setState({ rawMaterialDetails: details });
  };

  handleCheckbox = (e, name) => {
    let details = this.state.rawMaterialDetails;
    details[name] = !details[name];
    this.setState({ rawMaterialDetails: details });
  };

  handleToggle = (e) => {
    let checked = e.target.checked;
    this.setState({
      rawMaterialDetails: {
        ...this.state.rawMaterialDetails,
        labTestRequire: checked ? 1 : 0
      }
    });
  }

  resetForm = () => {
    let details = this.state.rawMaterialDetails;
    details.rmName = "";
    details.rmCode = "";
    details.eqTo = "";
    details.specification = "";
    details.specificationNo = "";
    details.rmUOM = "";
    details.rmCategory = "";
    details.rmPurchaseRate = null;
    details.rmPackQty = null;
    details.testingCharge = null;
    details.storageCondition = "";
    details.minQty = null;
    details.maxQty = null;
    details.sampleQty = null;
    details.reTestPeriod = null;
    details.batchWeight = "";
    details.assayCount = "";
    details.moistureCount = "";
    details.labTestRequire = false;

    let validation = this.state.validState;
    validation.isValid = true;
    validation.error = {};
    this.setState(
      {
        rawMaterialDetails: details,
        _id: "",
        validState: validation,
        searchByItemName: "",
        tableStatus: "",
        isEditing: false,
      },
      () => {
        this.getAllRawMaterials(this.state.searchByItemName);
      }
    );
  };

  addEditRawMaterial = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let request = this.state.rawMaterialDetails;
        if (request.batchWeight === "Yes") {
          request.batchWeight = 1;
        } else {
          request.batchWeight = 0;
        }

        if (request.assayCount === "Yes") {
          request.assayCount = 1;
        } else {
          request.assayCount = 0;
        }

        if (request.moistureCount === "Yes") {
          request.moistureCount = 1;
        } else {
          request.moistureCount = 0;
        }
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        request.labTestRequire = request.labTestRequire ? true : false;
        this.masterServices.addEditRawMaterial(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.resetForm();
            this.setState({ isGridView: true, isLoading: false }, () => {
              this.getAllRawMaterials(this.state.searchByItemName);
            });
          } else if (response.statusCode === 409) {
            this.SwalServices.Warning(response.Message);
            this.setState({ isGridView: true, isLoading: false });
          } else {
            this.SwalServices.Error(response.Message);
            this.setState({ isLoading: false })
          }
        });
      });
    }
  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };

  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true, isEditing: false });
  };

  searchByItemName = (event, name) => {
    let value = event.target.value;
    this.setState({ searchByItemName: value }, () => {
      this.getAllRawMaterials(this.state.searchByItemName);
    });
  };

  deleteRawMaterialById = (id) => {
    this.SwalServices.Confirm(
      "",
      ``,
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text,
      `Are you sure you want to delete this item?`
    ).then((response) => {
      if (response === true) {
        this.masterServices.deleteRawMaterialById(id).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.getAllRawMaterials(this.state.searchByItemName);
          } else {
            this.SwalServices.Error(response.Message);
          }
        });
      }
    });
  }

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.rawMaterialDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  render() {
    return (
      <div className="rawMaterial-page">
        {this.state.isGridView === true ? (
          <>
            <div className="item-search !mb-[10px]">
              <div className="item-grp">
                <div className="item-search-box w-[50%]">
                  <label>Item name</label>
                  <input
                    className="inputFocus"
                    type="text"
                    id="searchByItemName"
                    name="searchByItemName"
                    autocomplete="off"
                    value={this.state.searchByItemName}
                    onChange={(event) =>
                      this.searchByItemName(event, "searchByItemName")
                    }
                  />
                </div>
              </div>
              <button className="add-btn mt-3.5" onClick={() => this.closeGridView()}>
                Add new Item
              </button>
            </div>
            <div className="itemList-table">
              <p className="mb-[3px] text-[15px] font-medium text-[#474747]">Total Count :- {this.state.totalCount}</p>
              <div className="table-container" style={{ height: 'calc(100vh - 205px)' }}>
                <table className="itemList">
                  <thead>
                    <tr>
                      <td style={{ width: "30%" }}>Item Name</td>
                      <td style={{ width: "10%" }}>U.O.M</td>
                      <td style={{ width: "10%" }}>Category</td>
                      <td style={{ width: "10%" }}>Testing Charge</td>
                      <td style={{ width: "10%" }}>Minimum Qty.</td>
                      <td style={{ width: "10%" }}>Maximum Qty.</td>
                      <td style={{ width: "10%" }}>Batch Weight</td>
                      <td style={{ width: "10%", textAlign: "center" }}>
                        Action
                      </td>
                    </tr>
                  </thead>
                  <tbody >
                    {this.state.rawMaterialsLising &&
                      this.state.rawMaterialsLising.length > 0 ? (
                      this.state.rawMaterialsLising.map((item, key) => (
                        <>

                          <tr key={key}>
                            <td>{item.rmName}</td>
                            <td>{item.rmUOM}</td>
                            <td>{item.rmCategory}</td>
                            <td>{Number(item.testingCharge) > 0 ? Number(item.testingCharge).toFixed(2) : 0}</td>
                            <td>{item.minQty}</td>
                            <td>{item.maxQty}</td>
                            <td>{Number(item.batchWeight) > 0 ? Number(item.batchWeight).toFixed(2) : 0}</td>
                            <td style={{ textAlign: "center" }}>
                              <button
                                className="search-btn"
                                onClick={() => this.getRawMaterialById(item._id)}
                              >
                                <FontAwesomeIcon icon={faPen} />
                              </button>
                              <button
                                className="cancel-btn"
                                onClick={() =>
                                  this.deleteRawMaterialById(item._id)
                                }
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </td>
                          </tr>

                        </>
                      ))
                    ) : this.state.rawMaterialsLising
                      && this.state.rawMaterialsLising.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={8} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.rawMaterialsLising
                      && this.state.rawMaterialsLising.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : null}

        {this.state.isGridView === false ? (
          <div className="item-listing">
            <div className="item-form">
              <div className="form-table">
                <div className="item-grp grid grid-cols-2 !gap-2.5 !mb-3">
                  <div className="input-grp">
                    <label>Item Name</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.rmName ? "errorInput" : ""}`}
                      type="text"
                      id="rmName"
                      name="rmName"
                      autocomplete="off"
                      value={this.state.rawMaterialDetails.rmName}
                      onChange={(event) => this.handleChange(event, "rmName")}
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.rmName}
                    /> */}
                  </div>
                  <div className="inputInner-grp grid grid-cols-2 !gap-2.5">
                    <div className="input-grp">
                      <label>Eq. To</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="eqTo"
                        name="eqTo"
                        autocomplete="off"
                        value={this.state.rawMaterialDetails.eqTo}
                        onChange={(event) => this.handleChange(event, "eqTo")}
                      />
                    </div>
                    <div className="input-grp">
                      <label>Category</label>
                      <select
                        className={`inputFocus ${this.state.validState?.error?.rmCategory ? "errorInput" : ""}`}
                        name="rmCategory"
                        value={this.state.rawMaterialDetails.rmCategory}
                        onChange={(e) =>
                          this.handleDropdownChange(e, "rmCategory")
                        }
                      >
                        <option>Select</option>
                        {this.state.rmCategoryList.map((x, key) => (
                          <option key={key} value={x.rmCategory}>
                            {x.rmCategory}
                          </option>
                        ))}
                      </select>
                      {/* <ValidationText
                        error={this.state.validState.error.rmCategory}
                      /> */}
                    </div>
                  </div>
                </div>
                <div className="item-grp grid !grid-cols-4 !gap-2.5 !mb-3">
                  <div className="input-grp">
                    <label>Specification</label>
                    <input
                      className="inputFocus"
                      type="text"
                      id="specification"
                      name="specification"
                      autocomplete="off"
                      value={this.state.rawMaterialDetails.specification}
                      onChange={(event) =>
                        this.handleChange(event, "specification")
                      }
                    />
                  </div>
                  <div className="input-grp">
                    <label>Specification No</label>
                    <input
                      className="inputFocus"
                      type="number"
                      id="specificationNo"
                      name="specificationNo"
                      autocomplete="off"
                      value={this.state.rawMaterialDetails.specificationNo}
                      onChange={(event) =>
                        this.handleChange(event, "specificationNo")
                      }
                    />
                  </div>
                  <div className="input-grp">
                    <label>Std. Purch. Rate</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.rmPurchaseRate ? "errorInput" : ""}`}
                      type="number"
                      id="rmPurchaseRate"
                      name="rmPurchaseRate"
                      autocomplete="off"
                      value={this.state.rawMaterialDetails.rmPurchaseRate}
                      onChange={(event) =>
                        this.handleChange(event, "rmPurchaseRate")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.rmPurchaseRate}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Std. Pack Qty.</label>
                    <input
                      // className={`inputFocus ${this.state.validState?.error?.rmPackQty ? "errorInput" : ""}`}
                      type="number"
                      id="rmPackQty"
                      name="rmPackQty"
                      autocomplete="off"
                      value={this.state.rawMaterialDetails.rmPackQty}
                      onChange={(event) =>
                        this.handleChange(event, "rmPackQty")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.rmPackQty}
                    /> */}
                  </div>
                </div>
                <div className="item-grp grid !grid-cols-4 !gap-2.5 !mb-3">
                  <div className="input-grp">
                    <label>U-O-M</label>
                    <select
                      className={`inputFocus ${this.state.validState?.error?.rmUOM ? "errorInput" : ""}`}
                      name="rmUOM"
                      value={this.state.rawMaterialDetails.rmUOM}
                      onChange={(e) => this.handleDropdownChange(e, "rmUOM")}
                    >
                      <option>Select</option>
                      {this.state.rmUOMList.map((x, key) => (
                        <option key={key} value={x.uom}>
                          {x.uom}
                        </option>
                      ))}
                    </select>
                    {/* <ValidationText error={this.state.validState.error.rmUOM} /> */}
                  </div>
                  <div className="input-grp">
                    <label>Storage Condition</label>
                    <select
                      className={`inputFocus ${this.state.validState?.error?.storageCondition ? "errorInput" : ""}`}
                      name="storageCondition"
                      value={this.state.rawMaterialDetails.storageCondition}
                      onChange={(e) =>
                        this.handleDropdownChange(e, "storageCondition")
                      }
                    >
                      <option>Select</option>
                      {this.state.storageConditionList &&
                        this.state.storageConditionList.length > 0 &&
                        this.state.storageConditionList.map((code, key) => (
                          <option key={key} value={code.storageCondition}>
                            {code.storageCondition}
                          </option>
                        ))}
                    </select>
                    {/* <ValidationText
                      error={this.state.validState.error.storageCondition}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Testing Charge</label>
                    <input
                      // className={`inputFocus ${this.state.validState?.error?.testingCharge ? "errorInput" : ""}`}
                      type="number"
                      id="testingCharge"
                      name="testingCharge"
                      autocomplete="off"
                      value={this.state.rawMaterialDetails.testingCharge}
                      onChange={(event) =>
                        this.handleChange(event, "testingCharge")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.testingCharge}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>
                      Re-Test Period{" "}
                      <span style={{ fontSize: "14px", fontWeight: "500" }}>
                        (In Months)
                      </span>
                    </label>
                    <input
                      className="inputFocus"
                      type="number"
                      id="reTestPeriod"
                      name="reTestPeriod"
                      autocomplete="off"
                      value={this.state.rawMaterialDetails.reTestPeriod}
                      onChange={(event) =>
                        this.handleChange(event, "reTestPeriod")
                      }
                    />
                  </div>
                </div>
                <div className="item-grp grid !grid-cols-4 !gap-2.5 !mb-3">
                  <div className="input-grp">
                    <label>Minimum Qty.</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.minQty ? "errorInput" : ""}`}
                      type="number"
                      id="minQty"
                      name="minQty"
                      autoComplete="off"
                      value={this.state.rawMaterialDetails.minQty}
                      onChange={(event) => this.handleChange(event, "minQty")}
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.minQty}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Maximum Qty.</label>
                    <input
                      // className={`inputFocus ${this.state.validState?.error?.maxQty ? "errorInput" : ""}`}
                      type="number"
                      id="maxQty"
                      name="maxQty"
                      autoComplete="off"
                      value={this.state.rawMaterialDetails.maxQty}
                      onChange={(event) => this.handleChange(event, "maxQty")}
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.maxQty}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Sample Qty.</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.sampleQty ? "errorInput" : ""}`}
                      type="number"
                      id="sampleQty"
                      name="sampleQty"
                      autocomplete="off"
                      value={this.state.rawMaterialDetails.sampleQty}
                      onChange={(event) =>
                        this.handleChange(event, "sampleQty")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.sampleQty}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Moisture Count</label>
                    <select
                      name="moistureCount"
                      value={this.state.rawMaterialDetails.moistureCount}
                      onChange={(e) =>
                        this.handleDropdownChange(e, "moistureCount")
                      }
                    >
                      <option value={"Yes"}>Yes</option>
                      <option value={"No"}>No</option>
                    </select>
                  </div>
                </div>
                <div className="item-grp grid !grid-cols-4 !gap-2.5 !mb-3.5">
                  <div className="input-grp">
                    <label>Batch Weight </label>
                    <select
                      name="batchWeight"
                      value={this.state.rawMaterialDetails.batchWeight}
                      onChange={(e) =>
                        this.handleDropdownChange(e, "batchWeight")
                      }
                    >
                      <option value={"Yes"}>Yes</option>
                      <option value={"No"}>No</option>
                    </select>
                    <span style={{ fontSize: "12px", fontWeight: "500" }}>
                      This material will be calculate in Batch Weight
                    </span>
                  </div>
                  <div className="input-grp">
                    <label>Assay Count</label>
                    <select
                      name="assayCount"
                      value={this.state.rawMaterialDetails.assayCount}
                      onChange={(e) =>
                        this.handleDropdownChange(e, "assayCount")
                      }
                    >
                      <option value={"Yes"}>Yes</option>
                      <option value={"No"}>No</option>
                    </select>
                  </div>
                  {this.state.isPharmaSoftware ?
                    <div className="input-grp flex items-center gap-2">
                      <label className="!mb-0 whitespace-nowrap">Lab test require</label>
                      <ToggleSwitch
                        checked={this.state.rawMaterialDetails.labTestRequire === 1}
                        onChange={this.handleToggle}
                      />
                    </div>
                    : null}
                  <div className="itemInner-grp grid grid-cols-2 !gap-2.5">

                  </div>
                </div>
              </div>
              <div className="btn-grp">
                {this.state.isEditing === true ? (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditRawMaterial()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                  </button>
                ) : (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditRawMaterial()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                  </button>
                )}
                <button
                  disabled={this.state.isLoading}
                  className="cancel-btn"
                  onClick={() => this.openGridView()}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div >
    );
  }
}
export default rawMaterial;
